/* eslint-disable camelcase */

// TODO: Нужен рефактор на debounce отправки данных на сервер
// https://rtrack.ru/projects/vshsber/issues/477
import _debounce from 'lodash/debounce.js';
import { deepClone } from 'fast-json-patch';
import omit from 'lodash/omit.js';
import isEqual from 'lodash/isEqual.js';
import cloneDeep from 'lodash/cloneDeep.js';
import isNil from 'lodash/isNil.js';
import {
    addPageActivityQuestion,
    addPageActivityQuestionAnswer,
    removePageActivityQuestionAnswer,
    restorePageActivityQuestionAnswer,
    changePageActivityQuestionAnswer,
    getPageActivityQuestionImportExample,
    importPageActivityQuestions,
    exportPageActivityQuestions,
    exportPageActivityQuestionsWithAnswers,
    exportStudentsTestResult,
} from '@/api/activityQuestionApi.js';
import {
    downloadFile,
    getHtmlText,
    getNewBlockInstance,
    getNewBlockInstancePatch,
    getUploadProgress,
} from '@/utils/utils.js';
import { createCancelHttp, isHttpCancel, showErrorSnackbar as showError } from '@/utils/http.js';
import {
    DEBOUNCE_TIME,
    DEBOUNCE_TIME_CHANGE_ANSWER, DEFAULT_EACH_QUESTION_COUNT,
    IMAGE_EXTENSION,
    IMAGE_TYPES,
    SCORE_TYPE,
} from '@/constants/index.js';
import {
    QUESTION_TYPES,
    MATCHING_QUESTION_COLUMN_TYPES,
    DEFAULT_LIKERT_ANSWERS_LENGTH,
    MAX_QUESTIONS,
    MAX_ANSWERS,
    MAX_QUIZ_CARDS,
    MAX_LIKERT_LENGTH,
} from '@/components/Blocks/BlockTestOrQuiz/constants.js';
import {
    getDefaultQuestionOptions,
    getNormalizeQuestionData,
    getQuestion,
    getSimpleAnswer,
} from '@/components/Blocks/BlockTestOrQuiz/helpers.js';
import useSnackbar from '@/hooks/snackbars.js';
import { validateFile } from '@/utils/validators.js';
import { ACCEPT_FILE_IMPORT_TYPES } from '@editor-settings/views/TestOrQuizSettings/contants.js';
import { bytes } from '@/utils/helpers.js';
import { AiQuestionTypeToBlockQustionType } from '@/admin/components/AI/AiModal/contants.js';

const { createSnackbar } = useSnackbar();

const debouncedChangeActivityAnswer = {};

const createDebouncedChangeActivityAnswer = () => _debounce(async ({ dispatch }, { activityId, questionId, answerId, answerData, cancelToken }) => {
    try {
        const resp = await changePageActivityQuestionAnswer(
            questionId,
            answerId,
            answerData,
            {
                cancelToken,
            },
        );

        dispatch('saveActivityQuestionAnswer', {
            activityId,
            questionId,
            answerId,
            answerData: {
                ...answerData,
                ...resp.data,
            },
        });

        dispatch('setEditabledAnswerId', null);

        dispatch('updateInitialStructure');
    } catch (e) {
        if (!isHttpCancel(e)) {
            dispatch('setEditabledAnswerId', null);
            console.error('[createDebouncedChangeActivityAnswer action] save question answer error', e);
        }
    }
}, DEBOUNCE_TIME_CHANGE_ANSWER);

const isSimpleQuestion = question => [
    QUESTION_TYPES.SINGLE_CHOICE,
    QUESTION_TYPES.MULTIPLE_ANSWERS,
    QUESTION_TYPES.QUIZ_CARDS,
].includes(question.type);

const isSimpleQuestionEmpty = question => isSimpleQuestion(question) &&
    !getHtmlText(question.title) &&
    !getHtmlText(question.description) && question.answers.every(answer => !getHtmlText(answer.title) && (question.type !== QUESTION_TYPES.QUIZ_CARDS || !JSON.parse(answer.data || '{}')?.image));

/**
 * @param {Array} aiQuestions
 * @param {string} quizType
 * @param {number} [sectionId]
 * @returns {Array}
 */
const getQuestionsFromAiQuestions = (aiQuestions, quizType, sectionId) => aiQuestions.map(aiQuestion => {
    const newQuestion = getQuestion({
        title: aiQuestion.title || '',
        description: `<p>${aiQuestion.description || ''}</p>`,
        quizType,
        questionType: AiQuestionTypeToBlockQustionType[aiQuestion.type],
        sectionId,
    });

    newQuestion.answers = aiQuestion.answers.map((answer, ind) => ({
        ...getSimpleAnswer(ind, Number(answer.is_correct)),
        title: `<p>${answer.title || ''}</p>`,
    }));

    return newQuestion;
});

/**
 * @type {import('vuex').ActionTree<any, any>}
 */
const activityQuestionActions = {
    pushActivityQuestion({ commit }, { activityId, questionData }) {
        commit('questions/pushActivityQuestion', {
            activityId,
            questionData,
        }, {
            root: true,
        });
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, questionData }} payload
     */
    replaceActivityQuestion({ commit }, payload) {
        commit('questions/replaceActivityQuestion', payload, { root: true });
    },

    async reloadActivitySections({ dispatch, getters }, payload) {
        const currentActivity = getters.getActivity(payload.activityId);

        if (!currentActivity?.data?.settings?.sections?.is_enabled) return;

        await dispatch('questions/loadActivitySections', {
            ...payload,
            silent: true,
        }, { root: true });
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ type, quizType, activityId, sectionId, insertAfterQuestionId }} payload
     * @returns {Promise<*>}
     */
    // eslint-disable-next-line complexity,max-lines-per-function
    async addActivityQuestion({ dispatch, getters }, payload) {
        try {
            const { type, quizType, activityId, sectionId, insertAfterQuestionId } = payload;
            const currentActivity = getters.getActivity(activityId);

            dispatch('recalcTestOrQuizOptions', {
                activityId,
                sectionId,
            });

            const newQuestion = getQuestion({
                quizType: currentActivity?.data?.content?.type ?? quizType,
                questionType: QUESTION_TYPES.SINGLE_CHOICE,
                sectionId,
            });

            const { data: responseData } = await addPageActivityQuestion(activityId, [newQuestion]);
            const [createdQuestion] = responseData.data;

            if (currentActivity?.data?.settings?.routes?.is_enabled) {
                await dispatch('questions/loadQuestionRoutes', {
                    activityId,
                    questionId: createdQuestion.id,
                }, { root: true });
            }


            let newQuestionsOrderIds = null;

            if (insertAfterQuestionId) {
                const activityQuestions = sectionId
                    ? getters.getActivitySectionQuestions(activityId, sectionId)
                    : getters.getActivityQuestions(activityId);
                const questionsOrderIds = activityQuestions.map(q => q.id);
                const indexQuestionBefore = questionsOrderIds.indexOf(insertAfterQuestionId);
                const insertIndex = indexQuestionBefore + 1;

                newQuestionsOrderIds = questionsOrderIds.toSpliced(insertIndex, 0, createdQuestion.id);

                if (sectionId) {
                    // eslint-disable-next-line require-atomic-updates
                    createdQuestion.test_section_order = insertIndex;
                } else {
                    // eslint-disable-next-line require-atomic-updates
                    createdQuestion.order = insertIndex;
                }
            }

            await dispatch('pushActivityQuestion', {
                activityId,
                questionData: createdQuestion,
            });

            await dispatch('reloadActivitySections', { activityId });

            if (newQuestionsOrderIds) {
                dispatch('sortActivityQuestion', {
                    activityId,
                    order: newQuestionsOrderIds,
                });
            }

            if (type) {
                try {
                    await dispatch('changeQuestionType', {
                        blockId: activityId,
                        questionId: createdQuestion.id,
                        type,
                    });
                } catch (e) {
                    dispatch('removeActivityQuestion', {
                        activityId,
                        questionId: createdQuestion.id,
                    });
                    throw e;
                }

                return getters.getQuestion(activityId, createdQuestion.id);
            }

            return createdQuestion;
        } catch (error) {
            console.error('[addActivityQuestion action] add question error', error);

            return Promise.reject(error);
        }
    },

    resaveActivityQuestion({ dispatch, getters }, { activityId, questionId, prevQuestionData }) {
        const questionData = getters.getQuestion(activityId, questionId);

        dispatch('changeActivityQuestion', {
            activityId,
            questionId,
            questionData,
            prevQuestionData,
        });
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, questionData, withAnswers, prevQuestionData, immediate }} payload
     */
    async changeActivityQuestion({ dispatch, getters }, payload) {
        const { immediate, activityId, questionId, questionData, withAnswers, prevQuestionData } = payload;
        const normalizeQuestionData = getNormalizeQuestionData(questionData, prevQuestionData);

        const currQuestionDataWithoutAnswers = omit(questionData, ['answers']);
        const newQuestionDataWithoutAnswers = omit(normalizeQuestionData, ['answers']);
        const prevQuestionDataWithoutAnswers = omit(prevQuestionData || getters.getQuestion(activityId, questionId), ['answers']);

        const isNotNormalized = isEqual(currQuestionDataWithoutAnswers, newQuestionDataWithoutAnswers);
        const isNotChanged = isEqual(newQuestionDataWithoutAnswers, prevQuestionDataWithoutAnswers);
        const isArchivedChanged = prevQuestionDataWithoutAnswers.is_archived !== newQuestionDataWithoutAnswers.is_archived;

        if (isNotNormalized && isNotChanged && !withAnswers) return;

        await dispatch('replaceActivityQuestion', {
            activityId,
            questionId,
            questionData: normalizeQuestionData,
        });

        if (immediate) {
            await dispatch('saveActivityQuestion', {
                activityId,
                questionId,
                withAnswers,
                isArchivedChanged,
                cancelToken: createCancelHttp('cancelTokenSaveActivityQuestion').token,
            });
        } else {
            dispatch('debouncedSaveActivityQuestion', {
                activityId,
                questionId,
                withAnswers,
                isArchivedChanged,
                cancelToken: createCancelHttp('cancelTokenSaveActivityQuestion').token,
            });
        }
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, questionData, withAnswers, prevQuestionData }} payload
     */
    async changeActivityQuestionImmediate({ dispatch }, payload) {
        await dispatch('changeActivityQuestion', {
            ...payload,
            immediate: true,
        });
    },

    debouncedSaveActivityQuestion: _debounce(({ dispatch }, payload) => {
        dispatch('saveActivityQuestion', payload);
    }, DEBOUNCE_TIME),

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, withAnswers, isArchivedChanged, cancelToken }} payload
     * @returns {Promise<void>}
     */
    async saveActivityQuestion({ dispatch }, { isArchivedChanged, ...payload }) {
        await dispatch('questions/saveActivityQuestion', payload, { root: true });

        if (isArchivedChanged) {
            dispatch('reloadActivitySections', {
                activityId: payload.activityId,
                cancelToken: createCancelHttp('cancelReloadActivitySections').token,
            });
        }
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId }} payload
     * @returns {Promise<*>}
     */
    async copyActivityQuestion({ dispatch }, payload) {
        try {
            const { activityId } = payload;
            const newQuestion = await dispatch('questions/copyActivityQuestion', payload, { root: true });

            dispatch('refetchActivityAttachments', { blockId: activityId });

            return newQuestion;
        } catch (error) {
            console.error('[copyActivityQuestion action] copy question error', error);

            throw error;
        }
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId }} payload
     * @returns {Promise<*|Promise>}
     */
    async removeActivityQuestion({ dispatch }, payload) {
        try {
            const { activityId } = payload;

            await dispatch('questions/removeActivityQuestion', payload, { root: true });

            dispatch('reloadActivitySections', { activityId });

            dispatch('recalcTestOrQuizOptions', { activityId });
        } catch (error) {
            console.error('[removeActivityQuestion action] remove question error', error);

            throw error;
        }
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId }} payload
     * @returns {Promise<*>}
     */
    async restoreActivityQuestion({ dispatch }, payload) {
        try {
            const restoredQuestion = await dispatch('questions/restoreActivityQuestion', payload, { root: true });

            return restoredQuestion;
        } catch (error) {
            console.error('[restoreActivityQuestion action] restore question error', error);

            throw error;
        }
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, sectionId, order }} payload
     * @returns {Promise<*>}
     */
    async sortActivityQuestion({ dispatch }, payload) {
        try {
            await dispatch('questions/sortActivityQuestions', payload, { root: true });
        } catch (error) {
            console.error('[sortActivityQuestion action] sort question error', error);

            throw error;
        }
    },
    async addInitialChildrenAnswers({ dispatch }, { activityId, questionId, parentId, answerData = null }) {
        if (!parentId) return;

        const [{ data: childrenAnswer1 }, { data: childrenAnswer2 }] = await Promise.all([
            addPageActivityQuestionAnswer(questionId, {
                parent_id: parentId,
                is_correct: 1,
                data: answerData,
                order: 0,
            }),
            addPageActivityQuestionAnswer(questionId, {
                parent_id: parentId,
                is_correct: 0,
                data: answerData,
                order: 1,
            }),
        ]);

        dispatch('updateOrInsertAnswer', {
            activityId,
            questionId,
            parentId,
            newAnswer: [childrenAnswer1, childrenAnswer2],
        });
    },
    addInitalAnswersDitribCategory({ dispatch, getters }, { activityId, questionId }) {
        const question = getters.getQuestion(activityId, questionId);

        question?.answers?.forEach?.(answer => {
            dispatch('addInitialChildrenAnswers', {
                activityId,
                questionId,
                parentId: answer.id,
                answerData: JSON.stringify({ image: null }),
            });
        });
    },
    async addAnswerCategory({ dispatch, getters }, { activityId, questionId }) {
        const order = getters.getQuestionMaxOrderAnswer(activityId, questionId);

        const { data: newAnswer } = await addPageActivityQuestionAnswer(questionId, {
            is_correct: 1,
            data: JSON.stringify({ image: null }),
            order,
        });

        const [{ data: childrenAnswer1 }, { data: childrenAnswer2 }] = await Promise.all([
            addPageActivityQuestionAnswer(questionId, {
                parent_id: newAnswer.id,
                is_correct: 1,
                data: JSON.stringify({ image: null }),
                order: 0,
            }),
            addPageActivityQuestionAnswer(questionId, {
                parent_id: newAnswer.id,
                is_correct: 0,
                data: JSON.stringify({ image: null }),
                order: 1,
            }),
        ]);

        dispatch('updateOrInsertAnswer', {
            activityId,
            questionId,
            newAnswer: {
                ...newAnswer,
                children: [childrenAnswer1, childrenAnswer2],
            },
        });
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, parentId, newAnswer }} payload
     */
    updateOrInsertAnswer({ dispatch, commit, getters }, payload) {
        const { activityId, questionId } = payload;

        const prevQuestionData = getters.getQuestion(activityId, questionId);

        commit('questions/updateOrInsertAnswer', payload, { root: true });

        dispatch('resaveActivityQuestion', {
            activityId,
            questionId,
            prevQuestionData,
        });
    },
    // eslint-disable-next-line complexity
    async addActivityQuestionAnswer({ dispatch, getters }, { activityId, questionId, answerData = null }) {
        try {
            const order = getters.getQuestionMaxOrderAnswer(activityId, questionId, answerData?.parent_id);

            const getAnswerData = data => (data ? JSON.stringify(data) : null);

            const { parent_id, title, ...restAnswerData } = answerData || {};

            const { data } = await addPageActivityQuestionAnswer(questionId, {
                parent_id,
                is_correct: 0,
                data: getAnswerData(restAnswerData),
                order,
                title,
            });

            dispatch('updateOrInsertAnswer', {
                activityId,
                questionId,
                parentId: parent_id,
                newAnswer: data,
            });
        } catch (error) {
            console.error('[addActivityQuestionAnswer action] add question answer error', error);

            throw error;
        }
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, switchData }} payload
     * @returns {Promise<void>}
     */
    async switchAnswerWithChildCorrectAnswer({ dispatch }, payload) {
        try {
            const { activityId, questionId } = payload;

            await dispatch('questions/switchAnswerWithChildCorrectAnswer', payload, { root: true });

            dispatch('resaveActivityQuestion', {
                activityId,
                questionId,
            });
        } catch (error) {
            console.error('[switchAnswerWithChildCorrectAnswer action] switch answer withchild correct error', error);

            throw error;
        }
    },
    sendDebouncedActivityQuestionAnswer(ctx, payload) {
        const { activityId, questionId, answerId } = payload;
        const debounceKey = [activityId, questionId, answerId].join('_');

        if (!debouncedChangeActivityAnswer[debounceKey]) {
            debouncedChangeActivityAnswer[debounceKey] = createDebouncedChangeActivityAnswer();
        }

        debouncedChangeActivityAnswer[debounceKey](ctx, {
            ...payload,
            cancelToken: createCancelHttp(`saveActivityQuestionAnswer${answerId}`).token,
        });
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, answerData }} payload
     */
    saveActivityQuestionAnswer({ dispatch }, payload) {
        dispatch('questions/changeActivityQuestionAnswer', payload, { root: true });
    },
    async changeActivityQuestionAnswer({ dispatch, getters }, { activityId, questionId, answerId, answerData }) {
        try {
            const prevQuestionData = deepClone(getters.getQuestion(activityId, questionId));

            await dispatch('setEditabledAnswerId', questionId);

            await dispatch('saveActivityQuestionAnswer', {
                activityId,
                questionId,
                answerId,
                answerData,
            });

            dispatch('sendDebouncedActivityQuestionAnswer', {
                activityId,
                questionId,
                answerId,
                answerData,
            });

            dispatch('resaveActivityQuestion', {
                activityId,
                questionId,
                prevQuestionData,
            });

            return Promise.resolve();
        } catch (error) {
            console.error('[changeActivityQuestionAnswer action] add question answer error', error);

            return Promise.reject(error);
        }
    },
    /**
     * @param {import('vuex').ActionContext}
     * @param {{ activityId, questionId, answerData }} payload
     */
    async removeActivityQuestionAnswer({ dispatch, getters }, payload) {
        try {
            const { activityId, questionId, answerData } = payload;
            const prevQuestionData = getters.getQuestion(activityId, questionId);

            await removePageActivityQuestionAnswer(questionId, answerData.id);

            if (answerData.parent?.id) {
                await changePageActivityQuestionAnswer(
                    questionId,
                    answerData.parent?.id,
                    answerData.parent,
                );
            }

            await dispatch('questions/removeActivityQuestionAnswer', payload, { root: true });

            dispatch('resaveActivityQuestion', {
                activityId,
                questionId,
                prevQuestionData,
            });

            return Promise.resolve();
        } catch (error) {
            console.error('[removeActivityQuestionAnswer action] remove question answer error', error);

            return Promise.reject(error);
        }
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, answerData, answerIndex }} payload
     * @returns {Promise<*>}
     */
    async restoreActivityQuestionAnswer({ commit, dispatch, getters }, payload) {
        try {
            const { activityId, questionId, answerData, answerIndex } = payload;
            const { data } = await restorePageActivityQuestionAnswer(questionId, answerData.id);

            const currQuestion = getters.getQuestion(activityId, questionId);

            if (answerData.parent?.id) {
                const currQuestionAnswer = currQuestion?.answers.find(item => item.id === answerData.parent?.id);

                if (currQuestionAnswer && currQuestionAnswer.children) {
                    dispatch('changeActivityQuestionAnswer', {
                        activityId,
                        questionId,
                        answerId: answerData.parent?.id,
                        answerData: {
                            ...currQuestionAnswer,
                            children: currQuestionAnswer.children.toSpliced(answerIndex || -1, 0, data),
                            data: JSON.stringify({
                                ...JSON.parse(currQuestionAnswer.data),
                                sortData: currQuestionAnswer.children.map(item => item.id),
                            }),
                        },
                    });
                }
            } else {
                const newQuestion = {
                    ...currQuestion,
                    answers: currQuestion.answers.toSpliced(answerIndex, 0, data),
                };

                commit('questions/replaceActivityQuestion', {
                    activityId,
                    questionId,
                    questionData: newQuestion,
                }, { root: true });
            }

            dispatch('resaveActivityQuestion', {
                activityId,
                questionId,
            });
        } catch (error) {
            console.error('[restoreActivityQuestionAnswer action] restore question answer error', error);

            throw error;
        }
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, questionId, order, parentId }} payload
     * @returns {Promise<void>}
     */
    async sortActivityQuestionAnswers({ dispatch }, payload) {
        try {
            await dispatch('questions/sortActivityQuestionAnswers', payload, { root: true });
            dispatch('updateInitialStructure');
        } catch (error) {
            console.error('[sortActivityQuestionAnswers action] sort question answer error', error);

            throw error;
        }
    },

    async downloadTemplate(_, { blockId }) {
        const { data } = await getPageActivityQuestionImportExample(blockId);

        downloadFile(data);
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {number} payload.blockId
     * @returns {Promise<void>}
     */
    async exportXlsx(_, payload) {
        const { data } = await exportPageActivityQuestions(payload.blockId);

        downloadFile(data);
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {number} payload.blockId
     * @param {number} payload.devCenterId
     * @returns {Promise<void>}
     */
    async exportTest(_, payload) {
        try {
            const { devCenterId, blockId } = payload;

            await exportPageActivityQuestionsWithAnswers(blockId);

            createSnackbar({
                title: 'Отчет добавлен в очередь на обработку',
                message: 'По завершению обработки, отчет можно скачать на странице отчетов',
                type: 'info',
                size: 'large',
                link: {
                    text: 'Перейти в раздел',
                    iconPrepend: true,
                    route: {
                        name: 'AdminReports',
                        params: {
                            developmentCenterId: devCenterId,
                        },
                    },
                },
                // TODO
                // snackbarOptions: {
                //     id: `report_user_answers_${blockId}`,
                // },
            });
        } catch (e) {
            console.error(e);

            createSnackbar({
                type: 'error',
                message: 'Ошибка формирования отчета',
            });
        }
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {number} payload.activityId
     * @param {number} payload.versionId
     * * @param {number} payload.developmentCenterId
     * @returns {Promise<void>}
     */
    async exportStudentsTestResult(_, payload) {
        try {
            const { developmentCenterId, versionId, activityId } = payload;

            await exportStudentsTestResult({
                versionId,
                activityId,
            });

            createSnackbar({
                title: 'Отчет добавлен в очередь на обработку',
                message: 'По завершению обработки, отчет можно скачать на странице отчетов',
                type: 'info',
                size: 'large',
                link: {
                    text: 'Перейти в раздел',
                    iconPrepend: true,
                    route: {
                        name: 'AdminReports',
                        params: {
                            developmentCenterId,
                        },
                    },
                },
            });
        } catch (e) {
            console.error(e);

            createSnackbar({
                type: 'error',
                message: 'Ошибка формирования отчета',
            });
        }
    },
    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {string|number} payload.longreadId
     * @param {string|number} payload.blockId
     * @param {File} payload.file
     * @returns {Promise<void>}
     */
    async importExcel({ dispatch, commit }, { longreadId, blockId, file }) {
        try {
            commit('IMPORT_START', { blockId });

            await validateFile(file, {
                types: ACCEPT_FILE_IMPORT_TYPES,
            });

            const changeBlockInportProgress = progress => {
                commit('changeBlockInportProgress', {
                    blockId,
                    progress,
                });
            };

            const handleProgress = event => {
                const progress = getUploadProgress(event);

                changeBlockInportProgress(progress);
            };

            const { data } = await importPageActivityQuestions(blockId, file, handleProgress);

            changeBlockInportProgress(100);

            await dispatch('refetchActivity', {
                longreadId,
                blockId,
            });

            const { total_questions_count, imported_questions_count } = data;

            if (total_questions_count === imported_questions_count) {
                createSnackbar({
                    type: 'success',
                    message: 'Импорт успешно завершен',
                });
            } else {
                const snackbarTitle = imported_questions_count
                    ? `Успешно импортировано ${imported_questions_count} из ${total_questions_count}`
                    : `${imported_questions_count} из ${total_questions_count} импортировано`;
                const snackbarDescription = `${total_questions_count - imported_questions_count} вопроса импортировано с ошибкой. Проверьте правильность заполнения`;

                createSnackbar({
                    type: 'info',
                    title: snackbarTitle,
                    message: snackbarDescription,
                });
            }
        } catch (e) {
            showError(e);
        } finally {
            commit('IMPORT_FINISH', { blockId });
        }
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {string|number} payload.blockId
     * @param {string|number} payload.questionId
     * @param {string} payload.type
     */
    // eslint-disable-next-line max-lines-per-function, complexity, max-statements
    async changeQuestionType({ getters, dispatch }, payload) {
        const { blockId, questionId, type: newType } = payload;

        const block = getters.getActivity(blockId);
        const oldQuestion = getters.getQuestion(blockId, questionId);

        if (!oldQuestion || !block || !newType || oldQuestion.type === newType) return;

        const newQuestion = {
            ...oldQuestion,
            question_data: JSON.stringify(getDefaultQuestionOptions({
                quizType: block.data?.content?.type,
                questionType: newType,
            })),
            type: newType,
        };

        if ([QUESTION_TYPES.MATCHING, QUESTION_TYPES.GAPS_IN_TEXT, QUESTION_TYPES.DISTRIBUTE_BY_CATEGORY].includes(oldQuestion.type)) {
            newQuestion.answers = [
                getSimpleAnswer(1, 1),
                getSimpleAnswer(2),
            ];
        }

        const dipatchChangeActivityQuestion = async questionData => {
            await dispatch('changeActivityQuestionImmediate', {
                activityId: blockId,
                questionId,
                questionData,
                withAnswers: true,
            });
        };

        if ([QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.QUIZ_CARDS].includes(newType)) {
            let isCorrectSettled = false;

            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: newQuestion.answers.map(item => {
                    const is_correct = Number(item.is_correct && !isCorrectSettled);

                    if (is_correct) {
                        isCorrectSettled = true;
                    }

                    let data = null;

                    if (newType === QUESTION_TYPES.QUIZ_CARDS) {
                        let parsedData = JSON.parse(item.data || null);

                        if (Array.isArray(parsedData)) {
                            parsedData = {};
                        }

                        data = JSON.stringify({
                            image: null,
                            ...parsedData,
                        });
                    }

                    return {
                        ...item,
                        title: newType === QUESTION_TYPES.QUIZ_CARDS ? getHtmlText(item.title) : item.title,
                        data,
                        is_correct,
                    };
                }),
            });
        } else if (newType === QUESTION_TYPES.LIKERT_SCALE) {
            const convertedLikertAnswers = newQuestion.answers.map(answer => ({
                ...answer,
                title: getHtmlText(answer?.title ?? ''),
                is_correct: 1,
            })).slice(0, MAX_LIKERT_LENGTH);

            if (convertedLikertAnswers.length < DEFAULT_LIKERT_ANSWERS_LENGTH) {
                const diffLength = DEFAULT_LIKERT_ANSWERS_LENGTH - convertedLikertAnswers.length;
                const lastOrder = convertedLikertAnswers.length;

                for (let i = 0; i < diffLength; i++) {
                    convertedLikertAnswers.push(getSimpleAnswer(lastOrder + i));
                }
            }

            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: convertedLikertAnswers,
            });
        } else if (newType === QUESTION_TYPES.SORTING) {
            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: newQuestion.answers.map((item, idx) => ({
                    ...item,
                    order: idx + 1,
                })),
            });
        } else if (newType === QUESTION_TYPES.MATCHING) {
            const getAnswerSide = (order, side) => ({
                ...getSimpleAnswer(order),
                data: JSON.stringify({
                    correctAnswerId: null,
                    side,
                }),
            });

            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: [
                    getAnswerSide(1, MATCHING_QUESTION_COLUMN_TYPES.LEFT),
                    getAnswerSide(2, MATCHING_QUESTION_COLUMN_TYPES.LEFT),
                    getAnswerSide(3, MATCHING_QUESTION_COLUMN_TYPES.RIGHT),
                    getAnswerSide(4, MATCHING_QUESTION_COLUMN_TYPES.RIGHT),
                ],
            });
        } else if (newType === QUESTION_TYPES.GAPS_IN_TEXT) {
            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: [
                    getSimpleAnswer(1, 1),
                    getSimpleAnswer(2, 1),
                ],
            });
        } else if (newType === QUESTION_TYPES.DISTRIBUTE_BY_CATEGORY) {
            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: [
                    getSimpleAnswer(1, 0, JSON.stringify({ image: null })),
                    getSimpleAnswer(2, 0, JSON.stringify({ image: null })),
                ],
            });
            dispatch('addInitalAnswersDitribCategory', {
                activityId: blockId,
                questionId,
            });
        } else if (newType === QUESTION_TYPES.SLOTS) {
            const convertedSlotsAnswers = newQuestion.answers.map(answer => ({
                ...answer,
                title: getHtmlText(answer?.title ?? ''),
            }));

            await dipatchChangeActivityQuestion({
                ...newQuestion,
                answers: convertedSlotsAnswers,
            });
        } else {
            await dipatchChangeActivityQuestion(newQuestion);
        }

        if (newType === QUESTION_TYPES.INFORMATION) {
            dispatch('recalcTestOrQuizOptions', {
                activityId: blockId,
                sectionId: newQuestion.test_section_id,
            });
        }

        if (block.data?.settings?.routes?.is_enabled) {
            dispatch('questions/loadQuestionRoutes', {
                activityId: blockId,
                questionId,
            }, { root: true });
        }
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {File} payload.image
     * @param {string|number} payload.blockId
     * @param {string|number} payload.questionId
     * @param {string|number} payload.answerId
     * @param {string|number} [payload.parentId]
     * @returns {Promise<void>}
     */
    addImageAnswer({ dispatch, getters }, payload) {
        const { blockId, questionId, parentId, answerId, image } = payload;

        const prevAnswer = getters.getQuestionAnswer(blockId, questionId, answerId, parentId);
        const prevAnswerData = JSON.parse(prevAnswer.data || '{}');

        dispatch('uploadActivityAttachBase', {
            blockId,
            prevAttachId: prevAnswerData?.image?.attachment_id,
            uploadKey: answerId,
            file: image,
            validation: {
                types: IMAGE_TYPES,
                extensions: IMAGE_EXTENSION,
                maxSize: bytes('10mb'),
            },
            success: attach => {
                dispatch('applyAttachAnswer', {
                    blockId,
                    questionId,
                    answerId,
                    parentId,
                    attach,
                });
            },
        });
    },

    applyAttachAnswer({ dispatch, getters }, payload) {
        const {
            blockId, questionId, answerId, parentId, attach,
        } = payload;

        const answer = getters.getQuestionAnswer(blockId, questionId, answerId, parentId);

        if (!answer) return;

        const newAnswerData = {
            ...JSON.parse(answer.data),
            image: { attachment_id: attach.id },
        };

        const newAnswer = getNewBlockInstance(answer, JSON.stringify(newAnswerData), '/data');

        dispatch('changeActivityQuestionAnswer', {
            activityId: blockId,
            questionId,
            answerId,
            answerData: {
                parent_id: parentId,
                ...newAnswer,
            },
        });
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {string|number} payload.blockId
     * @param {string|number} payload.questionId
     * @param {string|number} payload.answerId
     * @param {string|number} [payload.parentId]
     */
    async removeImageAnswer({ dispatch, getters }, payload) {
        try {
            const { blockId, questionId, answerId, parentId } = payload;
            const answer = getters.getQuestionAnswer(blockId, questionId, answerId, parentId);
            const answerData = JSON.parse(answer?.data || '{}');
            const attachId = answerData?.image?.attachment_id;

            if (!answer || !attachId) return;

            await dispatch('removeActivityAttachment', {
                blockId,
                attachId,
            });

            dispatch('changeActivityQuestionAnswer', {
                activityId: blockId,
                questionId,
                answerId,
                answerData: {
                    parent_id: parentId,
                    ...answer,
                    data: JSON.stringify({
                        ...answerData,
                        image: null,
                    }),
                },
            });

            createSnackbar({
                type: 'timer',
                message: 'Изображение удалено',
                actionButton: {
                    iconName: 'undo',
                    text: 'Отмена',
                    on: {
                        click: () => {
                            dispatch('restoreImageAnswer', {
                                blockId,
                                questionId,
                                answerId,
                                parentId,
                                attachId,
                            });
                        },
                    },
                },
            });

        } catch (e) {
            showError(e);
        }
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {string|number} payload.blockId
     * @param {string|number} payload.questionId
     * @param {string|number} payload.answerId
     * @param {string|number} payload.attachId
     * @param {string|number} [payload.parentId]
     */
    async restoreImageAnswer({ dispatch, getters }, payload) {
        try {
            const { blockId, questionId, answerId, parentId, attachId } = payload;

            await dispatch('restoreActivityAttach', {
                blockId,
                attachId,
            });

            const currAnswer = getters.getQuestionAnswer(blockId, questionId, answerId, parentId);

            if (!currAnswer) return;

            dispatch('changeActivityQuestionAnswer', {
                activityId: blockId,
                questionId,
                answerId,
                answerData: {
                    parent_id: parentId,
                    ...currAnswer,
                    data: JSON.stringify({
                        ...JSON.parse(currAnswer.data || '{}'),
                        image: { attachment_id: attachId },
                    }),
                },
            });
        } catch (e) {
            showError(e);
        }
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {string|number} payload.blockId
     * @param {Array} payload.incorrectAnswers
     * @param {Function} [payload.preventDefault]
     */
    addAiCopiedIncorrectAnswers({ getters, dispatch }, payload) {
        const { blockId, incorrectAnswers, preventDefault } = payload;

        if (incorrectAnswers.length < 1) return;

        const currentQuestionId = getters.getBlockCurrentQuestion(blockId);
        const question = getters.getQuestion(blockId, currentQuestionId);

        const incorrectAnswersTmp = [...incorrectAnswers];

        if ([QUESTION_TYPES.QUIZ_CARDS, QUESTION_TYPES.MULTIPLE_ANSWERS, QUESTION_TYPES.SINGLE_CHOICE].includes(question.type)) {
            preventDefault?.();

            const newAnswers = question.answers.map(answer => {
                if (answer.is_correct) return answer;

                return {
                    ...answer,
                    title: incorrectAnswersTmp.shift() ?? '',
                };
            });

            if (incorrectAnswersTmp.length > 0 && newAnswers.length < MAX_ANSWERS) {
                const appendIncorrectAnswers = incorrectAnswersTmp.slice(0, MAX_ANSWERS - newAnswers.length);

                if (question.type === QUESTION_TYPES.QUIZ_CARDS) {
                    appendIncorrectAnswers.forEach(answer => {
                        newAnswers.push({
                            ...getSimpleAnswer(newAnswers.length),
                            title: answer,
                            data: JSON.stringify({ image: null }),
                        });
                    });
                } else {
                    appendIncorrectAnswers.forEach(answer => {
                        newAnswers.push({
                            ...getSimpleAnswer(newAnswers.length),
                            title: answer,
                        });
                    });
                }
            }

            dispatch('changeActivityQuestion', {
                activityId: blockId,
                questionId: currentQuestionId,
                withAnswers: true,
                questionData: {
                    ...question,
                    answers: newAnswers,
                },
            });
        }
    },

    /**
     * @param {import('vuex').ActionContext} store
     * @param {object} payload
     * @param {string|number} payload.blockId
     * @param {Array} payload.questions
     */
    // eslint-disable-next-line complexity
    async addAiCopiedQuestions({ dispatch, commit, getters, rootGetters }, payload) {
        const { blockId, questions } = payload;
        let block = getters.getActivity(blockId);
        const aiQuestions = Array.from(questions || []);

        if (!block || !aiQuestions.length) return;

        if (getters.getActivityQuestions(blockId).length >= MAX_QUESTIONS) {
            return createSnackbar({
                type: 'error',
                title: 'Ошибка добавления',
                message: 'Нет места для добавления ответа',
                size: 'large',
            });
        }

        const quizType = block.data?.content?.type;
        const isMicro = block.data?.content?.options?.isMicro;

        const blockCurrentQuestionId = getters.getBlockCurrentQuestion(blockId);
        const blockCurrentQuestion = getters.getQuestion(blockId, blockCurrentQuestionId);
        const currentSectionId = rootGetters['questions/getCurrentSection'](blockId)?.id || null;

        const newQuestionsFromAi = getQuestionsFromAiQuestions(aiQuestions, quizType, currentSectionId);
        let isCurrentQuestionWatchChanged = false;

        // проверяем на заполненость текущий вопрос, если не заполнен, то записываем его данные и сдвигаем ai вопросов
        if (isMicro || isSimpleQuestionEmpty(blockCurrentQuestion)) {
            isCurrentQuestionWatchChanged = true;

            const aiFirstQuestion = newQuestionsFromAi.shift();
            const { type, title, description, answers } = aiFirstQuestion;

            let questionData = {
                ...blockCurrentQuestion,
                type,
                title,
                description,
                answers,
            };

            if (blockCurrentQuestion.type === QUESTION_TYPES.QUIZ_CARDS && type === QUESTION_TYPES.SINGLE_CHOICE) {
                questionData = {
                    ...questionData,
                    type: QUESTION_TYPES.QUIZ_CARDS,
                    answers: answers
                        .map(answer => ({
                            ...answer,
                            title: getHtmlText(answer.title),
                            data: JSON.stringify({ image: null }),
                        }))
                        .slice(0, MAX_QUIZ_CARDS),
                };
            }

            await dispatch('changeActivityQuestionImmediate', {
                activityId: blockId,
                questionId: blockCurrentQuestionId,
                questionData,
                withAnswers: true,
            });
        }

        if (isMicro) return;

        block = getters.getActivity(blockId);

        const newQuestionsFromAiSliced = newQuestionsFromAi.slice(0, MAX_QUESTIONS - getters.getActivityQuestions(blockId).length);

        if (!newQuestionsFromAiSliced.length) return;

        const { data: respData } = await addPageActivityQuestion(blockId, newQuestionsFromAiSliced);

        const createdQuestions = respData.data;
        const createdQuestionsIds = createdQuestions.map(item => item.id);


        const oldQuestions = getters.getActivityCurrentQuestions(blockId);
        const oldQuestionsIds = oldQuestions.map(item => item.id);
        const insertIndex = oldQuestionsIds.indexOf(blockCurrentQuestionId) + 1;

        const newQuestionsOrderIds = oldQuestionsIds.toSpliced(insertIndex, 0, ...createdQuestionsIds);

        commit('questions/setActivityQuestions', {
            activityId: blockId,
            questions: [
                ...getters.getActivityQuestions(blockId),
                ...createdQuestions,
            ],
        }, { root: true });

        await dispatch('sortActivityQuestion', {
            activityId: blockId,
            sectionId: currentSectionId,
            order: newQuestionsOrderIds,
        });

        if (isCurrentQuestionWatchChanged) return;

        const questionId = createdQuestionsIds[0];

        commit('changeCurrentQuestionId', {
            blockId,
            questionId,
        });
        dispatch('activateBlock', {
            blockId,
            element: questionId,
        });
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, sectionId }} payload
     */
    // eslint-disable-next-line complexity
    async recalcTestOrQuizOptions({ getters, rootGetters, dispatch }, payload) {
        try {
            const { activityId, sectionId } = payload;

            if (getters.isTestOrQuizSectionEnabled(activityId)) {
                const recalcSectionId = sectionId || rootGetters['questions/getCurrentSection'](activityId)?.id;

                if (recalcSectionId) {
                    await dispatch('questions/recalcSectionOptions', {
                        activityId,
                        sectionId: recalcSectionId,
                    }, { root: true });
                }
            }

            const block = getters.getActivity(activityId);

            if (!block) return;


            const { settings, content: { options } } = block.data;
            const { questionsToSend, passingMinimum } = options;
            const newOptions = cloneDeep(options);

            const hasInformationQuestion = rootGetters['questions/getIsHasInformationQuestion']({ activityId });
            const maxStudentAnswer = rootGetters['questions/getMaxCountQuestionShouldAnswered']({
                activityId,
                withSections: settings.sections.is_enabled,
            });
            const maxScoredQuestions = rootGetters['questions/getMaxCountQuestionAffectResult']({
                activityId,
                withSections: settings.sections.is_enabled,
            });

            if (questionsToSend || passingMinimum) {
                if (!isNil(questionsToSend)) {
                    if (Number(questionsToSend) >= maxStudentAnswer) {
                        newOptions.questionsToSend = null;
                    }

                    if (isNil(sectionId) && hasInformationQuestion) {
                        newOptions.questionsToSend = null;
                    }
                }

                if (!settings.routes.is_enabled && !isNil(passingMinimum) && Number(passingMinimum) >= maxScoredQuestions) newOptions.passingMinimum = null;
            }

            if (!isEqual(options, newOptions)) {
                const newBlock = getNewBlockInstance(block, newOptions, '/data/content/options');

                dispatch('changeBlock', newBlock);
            }
        } catch (e) {
            console.error('[recalcTestOrQuizOptions]', e);
        }
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, enabled }} payload
     */
    async changeEnabledSections({ getters, dispatch }, payload) {
        const { activityId, enabled } = payload;
        const block = getters.getActivity(activityId);

        if (!block) return;

        const newBLockData = getNewBlockInstancePatch(block, [
            ['/data/settings/sections/is_enabled', enabled],
            ...(enabled
                ? [
                    ['/data/content/options/shakeQuestions', false],
                    ['/data/content/options/linearPassing', false],
                    ['/data/content/options/passingMinimum', null],
                    ['/data/content/options/questionsToSend', null],
                ]
                : []),
        ]);

        await dispatch('saveActivityData', {
            block: newBLockData,
        });
    },

    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, enabled }} payload
     */
    async changeEnabledRoutes({ getters, dispatch }, payload) {
        const { activityId, enabled } = payload;
        const block = getters.getActivity(activityId);

        if (!block) return;

        const newBlockData = getNewBlockInstancePatch(block, [
            ['/data/settings/routes', block.data.settings?.routes || {}],
            ['/data/settings/routes/is_enabled', enabled],
            ...(enabled
                ? [
                    ['/data/settings/sections/is_enabled', false],
                    ['/data/content/options/shakeQuestions', false],
                    ['/data/content/options/linearPassing', true],
                    ['/data/content/options/questionsToSend', null],
                ]
                : []),
        ]);

        await dispatch('saveActivityData', {
            block: newBlockData,
        });
    },
    /**
     * @param {import('vuex').ActionContext} ctx
     * @param {{ activityId, type, eachQuestionCount }} payload
     */
    async changeScoreType({ getters, dispatch }, payload) {
        const { activityId, type, eachQuestionCount } = payload;
        const block = getters.getActivity(activityId);

        if (!block) return;

        const getPatch = () => {
            if (type === SCORE_TYPE.EACH_QUESTION) {
                return [['/data/content/options/questionsToSend', null]];
            }

            if (type === SCORE_TYPE.SAME_FOR_EACH_QUESTION && isNil(eachQuestionCount)) {
                return [['/data/settings/score/each_question_count', DEFAULT_EACH_QUESTION_COUNT]];
            }

            return [];
        };

        const newBlockData = getNewBlockInstancePatch(block, [
            ['/data/settings/score/type', type],
            ...getPatch(),
        ]);

        await dispatch('saveActivityData', {
            block: newBlockData,
        });

        await dispatch('questions/recalcAllSection', {
            activityId,
        }, { root: true });
    },
};

export default activityQuestionActions;
